import React from "react";
import { connect } from "react-redux";
import {
  NameCell,
  Row,
  Name,
  Benchmark,
  PassIcon,
  FailIcon,
  Filler,
} from "./style.js";
import _ from "lodash";
import { domainKeys } from "../../../../modules/magnetDomains";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import { getBenchmarkLabel } from "../../../../lib/utils";
import BenchmarkPopover from "../BenchmarkPopover/index.jsx";

function DataTableRow({
  unit,
  magnetWorkSettings,
  selectedDomains,
  benchmarks,
  magnetReport,
}) {
  const magnetWorkSetting = magnetWorkSettings[unit];
  const appliedBenchmark = magnetWorkSetting.appliedBenchmark;

  const getValue = (key) => {
    return magnetWorkSetting.domains[key][0].data[0].percent;
  };

  const getBenchmark = (key) => {
    return benchmarks.data[appliedBenchmark][key];
  };

  const domainPass = (key) => {
    const value = getValue(key);
    const benchmark = getBenchmark(key);
    return value > benchmark;
  };

  const showBenchmark =
    appliedBenchmark !== magnetReport.workSettingBenchmarks.split(",")[0];

  const checkOrX = (key) => {
    if (domainPass(key)) {
      return <PassIcon showBenchmark={showBenchmark} />;
    } else {
      return <FailIcon showBenchmark={showBenchmark} />;
    }
  };

  return (
    <Grid container spacing={2} className="row">
      <Grid item className="column work-setting-column">
        <NameCell>
          <Row>
            <Filler />
            <Name>{unit}</Name>
            <BenchmarkPopover
              unit={unit}
              magnetWorkSettings={magnetWorkSettings}
              magnetReport={magnetReport}
            />
          </Row>
          {showBenchmark && (
            <Benchmark>{getBenchmarkLabel(appliedBenchmark, unit)}</Benchmark>
          )}
        </NameCell>
      </Grid>
      {_.map(domainKeys, (key) => (
        <Grid
          item
          key={key}
          className={clsx(
            "column data-column",
            selectedDomains.has(key) ? "selected" : ""
          )}
        >
          <div>
            <div>
              {checkOrX(key)}
              <span>{getValue(key)}%</span>
            </div>
            {showBenchmark && <Benchmark>{getBenchmark(key)}%</Benchmark>}
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default connect((store) => {
  return {
    benchmarks: store.benchmarks,
  };
})(DataTableRow);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/DataTableRow/index.jsx